// extracted by mini-css-extract-plugin
export default {"list-item":"c_g","list-item--navitem":"c_h"};